<template>
  <div class="empty-box tc">
    <img src="https://res.ponhu.cn/appr/res-appr_zl_14.png" class="icon-nodata" />
    <div class="empty-text">好像没有找到优惠券</div>
    <input type="button" class="btn" value="获取优惠券" @click="goInvite" />
  </div>
</template>

<script>
export default {
  methods: {
    goInvite () {
      this.$router.push({ path: '/appraiser/info/invitehelp' })
    }
  }
}
</script>

<style lang="less" scoped>
.empty-box {
  padding: 2.4rem 0 0;
  align-items: center;
  justify-content: center;
  text-align: center;
  .icon-nodata {
    width: 2.05rem;
    height: 2.22rem;
    margin-bottom: .1rem;
    margin: auto;
  }
  .empty-text {
    font-size: .28rem;
    text-align: center;
    color: #CCCCCC;
    font-weight:400;
  }
  .btn {
    border: 0;
    margin-top: .23rem;
    width:1.8rem;
    height:.56rem;
    background:rgba(255,209,51,1);
    box-shadow:0px 6px 20px 0px rgba(255,209,51,0.3);
    border-radius:32px;
    font-size:.24rem;
    font-weight:500;
    color:rgba(40,40,40,1);
  }
}
</style>
